import moment from "moment"

const YYYY_MM_DD_FORMAT = "YYYY-MM-DD"
const MM_DD_YYYY_FORMAT = "MM/DD/YYYY"

const getDayFromDate = (date) => moment(date).format('ddd')

const getMonthFromDate = (date) => moment(date).format('MMM')

const getPlainDate = (date) => moment(date).format('D')

const getCurrentDate = () => new Date()

const getFormattedDate = (format, date) => moment(date).format(format)

const getCurrentTime = () => Date.now();

const isDateSameOrBefore = (startDate, endDate, companreDate) => {

    const start = moment(startDate);
    const end = moment(endDate)
    const date = moment(companreDate);

    return date.isSameOrBefore(start, end);
}

const convertGmtToDateRange = (dateObj) => {
    const start = dateObj && dateObj.start;
    const end = dateObj && dateObj.end;
    let fmt = 'YYYY-MM-DD';
    const formatObj = {
        start: moment(start).format(fmt),
        end: moment(end).format(fmt)
    }
    return formatObj;
}

const calculateMonthDifference = (date1, date2) => {
    return (
      date2.getMonth() -
      date1.getMonth() +
      12 * (date2.getFullYear() - date1.getFullYear())
    );
  };
const changeDateToGivenFormat = (dateStr, formatStr) => moment(dateStr).format(formatStr)

const getTimeDiffInMinutes = (startDate, endDate) => {
  const duration = moment(endDate, "MMM DD YYYY h:mmA").diff(moment(startDate, "MMM DD YYYY h:mmA"), 'minutes')
  return duration
}

/**
 * Function to format dock start time and end time
 * @param {*} data 
 * @returns 
 */
const getDockOperationalTime=(data)=>{
  if (data.includes('GMT')) {
    return changeDateToGivenFormat(data,'HH:mm')
  }
  else{
    // let time=data.split('T')[1];
    let hours=data.split(':')[0]
    let min=data.split(':')[1]
    return `${hours}:${min}`
  }
}

const getDate = (input) => {
  const m = moment.utc(input);

  // Extract date and time separately
  return m.format('MM/DD/YYYY');     // '2025-08-01'
 
}

const getTime = (input) => {
  const m = moment.utc(input);
  // Extract date and time separately
  return m.format('HH:mm');       // '00:11:00'
}

const getPSTTimezone=()=>{
  return 'America/Los_Angeles'
}

function addDaysToDate(date, daysToAdd) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + daysToAdd);
  return newDate;
}

    //used to fetch appointments report list
    const getLocalDateString = (dateObj) => {
        if (!dateObj) return null;
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

export { getDayFromDate, getPlainDate, getCurrentDate, YYYY_MM_DD_FORMAT, getFormattedDate, getCurrentTime, convertGmtToDateRange, isDateSameOrBefore, getMonthFromDate, MM_DD_YYYY_FORMAT, changeDateToGivenFormat, calculateMonthDifference, getTimeDiffInMinutes, getDockOperationalTime, getPSTTimezone, addDaysToDate, getDate, getTime,getLocalDateString }